import type { TRule } from 'fela';

export const form: TRule = () => ({});
